import { useMemo, useState } from 'react';
import ImageUploadTicketComponente from './imageTiketUpload';
export const useUploadImageTicketComponent = () => {
  const [imagen1, setImagen1] = useState<File | null>(null);
  const [imagen2, setImagen2] = useState<File | null>(null);

  const UploadImageTicket= useMemo(
    () => ImageUploadTicketComponente,
[
  imagen1,
  imagen2
]
  )
return{
  UploadImageTicket,
  imagen1,
  setImagen1,
  imagen2,
  setImagen2
}
} 